import { TransactionDirection } from "@bitwarden/web-vault/app/models/enum/transactionDirection";
import { TransactionStatusEnum } from "@bitwarden/web-vault/app/models/enum/transactionType";
import { GlossDateFactory } from "@bitwarden/web-vault/app/models/data/shared/gloss-date/gloss-date.factory";
import { DEFAULT_CLASSIFICATION_ID } from "@bitwarden/web-vault/app/models/constants/classification.constants";
import { GLOSS_CREDITS_CATEGORY_ID } from "@bitwarden/web-vault/app/models/constants/category.constants";
import { TransactionStoreModel } from "@bitwarden/web-vault/app/models/store/transaction.store.model";
import { AccountView } from "@bitwarden/web-vault/app/models/view/account/account.view";
import { ITransactionResponse } from "@bitwarden/web-vault/app/models/interfaces/credits.interfaces";
import { TransactionType } from "@bitwarden/web-vault/app/models/enum/credits.enum";

const GLOSS_CREDITS_CURRENCY = "AUD";
const GLOSS_CREDITS_ORIGIN = "system";

export function mapGlossCreditsTransactionToStoreModel(
  apiTransaction: ITransactionResponse,
  account: AccountView,
): TransactionStoreModel {
  const direction =
    apiTransaction.type === TransactionType.DEPOSIT
      ? TransactionDirection.In
      : TransactionDirection.Out;
  const amount = Math.abs(Number(apiTransaction.amount));
  const dateISO = apiTransaction.createdAt ?? new Date().toISOString();
  const glossDate = GlossDateFactory.createFromISOString(dateISO, false, null);

  return {
    id: `gloss-credits-${apiTransaction._id}`,
    dc: new Date().toISOString(),
    dm: new Date().toISOString(),
    v: 9,
    vid: "",
    acId: account.id,
    ori: GLOSS_CREDITS_ORIGIN as any,
    bIB: undefined,
    bIBO: undefined,
    alc: [{ ctId: GLOSS_CREDITS_CATEGORY_ID, clId: DEFAULT_CLASSIFICATION_ID, spt: amount }],
    dfn: TransactionStatusEnum.transaction,
    dir: direction,
    dsc: apiTransaction.type === TransactionType.DEPOSIT ? "Deposit" : "Withdrawal",
    knd: apiTransaction.type ?? "",
    lTid: [],
    xLid: [],
    sts: "posted",
    qty: {
      cvrt: null,
      cvsym: "AUD",
      ccy: GLOSS_CREDITS_CURRENCY,
      qty: {
        amt: amount,
        prcs: 8,
        sym: apiTransaction.currency,
      },
    },
    srId: apiTransaction._id,
    tDt: glossDate.toGlossDateAsObject(),
    pDt: glossDate.toGlossDateAsObject(),
    vlPc: 0,
    del: false,
  };
}
